import { Helmet } from 'react-helmet-async';
import { getTokenPageStructuredData } from './structured-data';

interface TokenPageSEOProps {
  title?: string;
  description?: string;
  canonicalUrl?: string;
}

export function TokenPageSEO({
  title = "Create BEP20 Token | Mobile-Ready BSC Token Generator | Multi-Wallet Support",
  description = "Create your own BEP20 token on BSC with full mobile wallet support (SafePal, Trust Wallet, MetaMask). Instant token deployment, automated verification, and one-click wallet integration.",
  canonicalUrl = "https://mdbapp.io/create"
}: TokenPageSEOProps) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      
      {/* OpenGraph tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="MDBApp.io" />
      <meta property="og:image" content="https://mdbapp.io/MdbAppIoLogoNew.png" />
      
      {/* Twitter Card tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content="https://mdbapp.io/MdbAppIoLogoNew.png" />
      
      {/* Mobile tags */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      
      {/* Keywords */}
      <meta name="keywords" content="mobile token creator, SafePal token creator, Trust Wallet token generator, create token, BEP20 token, BSC token generator, create cryptocurrency, token creator, Binance Smart Chain, BSC token, create BEP20, token generator, crypto token, token launch, DeFi token, gas efficient, mobile DeFi" />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(getTokenPageStructuredData())}
      </script>
    </Helmet>
  );
}
